module.exports = __webpack_public_path__ + "xz.png?e3172c9980e4a7597cbb52e503ac3363";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xz.png
// module id = 671
// module chunks = 0